import { render, staticRenderFns } from "./TableKitchenForm.vue?vue&type=template&id=95c0a39a&scoped=true"
import script from "./TableKitchenForm.vue?vue&type=script&lang=js"
export * from "./TableKitchenForm.vue?vue&type=script&lang=js"
import style0 from "./TableKitchenForm.vue?vue&type=style&index=0&id=95c0a39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c0a39a",
  null
  
)

export default component.exports